<template>
  <v-dialog v-model="dialog" persistent max-width="500px">
    <template v-slot:activator="{ on }">
      <v-btn
        :text="!fromSummary"
        color="primary"
        class="text-capitalize font-weight-bold"
        :class="fromSummary ? 'btn-medium' : ''"
        :depressed="fromSummary"
        v-on="on"
        @click="afterBright"
      >
        <v-img
          v-if="!fromSummary"
          src="@/assets/images/icon-doc.png"
          width="16"
          height="16"
          class="mr-2"
        />
        Preval Number
      </v-btn>
    </template>
    <v-card class="rounded-10">
      <ValidationObserver ref="obs">
        <v-form @submit.prevent="uploadPrevalNumber" class="pa-0">
          <v-card-title
            class="primary white--text fs-16 lh-20 font-weight-bold py-4 px-6 pr-0 rounded-top-left-10 rounded-top-right-10"
          >
            <span class="pa-0">
              Preval Number - Information
            </span>
            <v-spacer />
            <v-col cols="auto" class="py-0">
              <v-icon @click="closeDialog" color="white">
                close
              </v-icon>
            </v-col>
          </v-card-title>
          <v-card-text class="pb-0">
            <v-row align="center">
              <v-col sm12>
                <ValidationProvider
                  name="Preval Number"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label
                    class="mb-1 fs-12 font-weight-regular"
                    for="prevalNumber"
                  >
                    Preval Number
                  </label>
                  <img
                    v-if="loadingPreval"
                    src="@/assets/images/loading-bar.gif"
                    class="pl-1"
                    style="height: 22px;position: absolute;"
                    alt="loader"
                    :disabled="disabledPreval"
                    :filled="disabledPreval"
                  />
                  <v-text-field
                    id="prevalNumber"
                    placeholder="Input Preval Number"
                    single-line
                    type="number"
                    dense
                    outlined
                    :error-messages="errors"
                    v-model="preval.preval_number"
                    autocomplete="off"
                    :disabled="disabledPreval"
                    :filled="disabledPreval"
                  ></v-text-field>
                </ValidationProvider>
                <ValidationProvider
                  name="Vendor"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label class="mb-1 fs-12 font-weight-regular" for="vendor">
                    Vendor
                  </label>
                  <img
                    v-if="loadingVendor || loadingPreval"
                    src="@/assets/images/loading-bar.gif"
                    class="pl-1"
                    style="height: 22px;position: absolute;"
                    alt="loader"
                  />
                  <v-autocomplete
                    id="vendor"
                    placeholder="Select Vendor"
                    single-line
                    dense
                    outlined
                    :error-messages="errors"
                    :items="vendors"
                    v-model="preval.vendor"
                    autocomplete="off"
                    item-text="name"
                    return-object
                    :disabled="disabledPreval"
                    :filled="disabledPreval"
                  ></v-autocomplete>
                </ValidationProvider>
                <ValidationProvider
                  slim
                  name="Preval Document"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label
                    for="prevalDocument"
                    class="fs-12 font-weight-regular mb-1"
                  >
                    Preval Document
                  </label>
                  <img
                    v-if="loadingPreval"
                    src="@/assets/images/loading-bar.gif"
                    class="pl-1"
                    style="height: 22px;position: absolute;"
                    alt="loader"
                  />
                  <div
                    v-if="
                      preval.prevalDoc &&
                        Object.keys(preval.prevalDoc).length > 0 &&
                        disabledPreval
                    "
                  >
                    <supporting-document-link
                      :detail="preval.prevalDoc"
                      :sshcp="true"
                      name="Preval Document"
                      small
                    />
                  </div>
                  <v-file-input
                    v-else
                    id="prevalDocument"
                    :disabled="disabledPreval"
                    :filled="disabledPreval"
                    :placeholder="
                      preval.prevalDoc &&
                      Object.keys(preval.prevalDoc).length > 0
                        ? preval.prevalDoc.file_name_origin
                        : 'Preval Document'
                    "
                    single-line
                    prepend-icon=""
                    append-icon="mdi-attachment"
                    dense
                    outlined
                    :error-messages="errors"
                    v-model="preval.prevalDoc"
                  ></v-file-input>
                  <div
                    v-if="
                      preval.prevalDoc &&
                        Object.keys(preval.prevalDoc).length > 0 &&
                        !disabledPreval
                    "
                  >
                    <supporting-document-link
                      :detail="preval.prevalDoc"
                      :sshcp="true"
                      name="Preval Document"
                      small
                    />
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  v-if="
                    preval.local_status === 'waiting for receipt' ||
                      preval.local_status === 'waiting to complete'
                  "
                  slim
                  name="Receipt"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label
                    for="invoiceReceipt"
                    class="fs-12 font-weight-regular mb-1"
                  >
                    Receipt
                  </label>
                  <img
                    v-if="loadingPreval"
                    src="@/assets/images/loading-bar.gif"
                    class="pl-1"
                    style="height: 22px;position: absolute;"
                    alt="loader"
                  />
                  <div
                    v-if="
                      (preval.receipt &&
                        Object.keys(preval.receipt).length > 0 &&
                        disabledPreval) ||
                        preval.local_status === 'waiting to complete'
                    "
                  >
                    <supporting-document-link
                      :detail="preval.receipt"
                      :sshcp="true"
                      name="Receipt"
                      small
                    />
                  </div>
                  <v-file-input
                    v-else
                    id="invoiceReceipt"
                    placeholder="Receipt"
                    single-line
                    prepend-icon=""
                    append-icon="mdi-attachment"
                    dense
                    outlined
                    :disabled="preval.local_status === 'waiting to complete'"
                    :filled="preval.local_status === 'waiting to complete'"
                    :error-messages="errors"
                    v-model="preval.receipt"
                  ></v-file-input>
                  <div
                    v-if="
                      preval.receipt &&
                        Object.keys(preval.receipt).length > 0 &&
                        !disabledPreval
                    "
                  >
                    <supporting-document-link
                      :detail="preval.receipt"
                      :sshcp="true"
                      name="Receipt"
                      small
                    />
                  </div>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions
            class="pb-6 px-6"
            v-if="
              preval.local_status === 'fully approved' ||
                preval.local_status === 'preval reject' ||
                preval.local_status === 'waiting for receipt'
            "
          >
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              class="btn-medium px-4"
              type="submit"
              :loading="loadingSubmitPreval"
            >
              Submit
            </v-btn>
            <v-btn
              color="#bd1e19"
              dark
              @click="closeDialog()"
              class="btn-medium px-4"
            >
              Cancel
            </v-btn>
          </v-card-actions>
          <v-card-actions
            class="px-1"
            v-else-if="
              preval.local_status === 'waiting hn approval' ||
                preval.local_status === 'waiting bo approval' ||
                preval.local_status === 'waiting to complete'
            "
          >
            <v-col>
              <v-btn
                color="primary"
                class="btn-medium mb-2"
                block
                :loading="loadingSubmitPreval"
                @click="approvePreval()"
              >
                {{
                  preval.local_status === 'waiting to complete'
                    ? 'Complete'
                    : 'Approve'
                }}
              </v-btn>
              <v-btn
                v-if="preval.local_status !== 'waiting to complete'"
                color="#bd1e19"
                dark
                block
                :loading="loadingRejectPreval"
                @click="rejectPreval()"
                class="btn-medium"
              >
                Reject
              </v-btn>
            </v-col>
          </v-card-actions>
        </v-form>
      </ValidationObserver>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import SupportingDocumentLink from '@/components/SSHCF/SupportingDocumentLink';

export default {
  props: {
    item: {
      default: {}
    },
    fromSummary: {
      default: false
    }
  },
  components: {
    SupportingDocumentLink
  },
  name: 'preval-approval',
  data: () => ({
    dialog: false,
    loadingPreval: false,
    loadingVendor: false,
    disabledPreval: false,
    loadingSubmitPreval: false,
    loadingRejectPreval: false,
    preval: {
      preval_number: '',
      vendor: {},
      prevalDoc: null,
      receipt: null,
      local_status: ''
    },
    form_id: null
  }),
  watch: {
    'preval.local_status'(val) {
      if (val === 'fully approved' || val === 'preval reject') {
        this.disabledPreval = false;
      } else {
        this.disabledPreval = true;
      }
    }
  },
  computed: {
    ...mapState('sshcp', {
      vendors: 'vendors'
    })
  },
  methods: {
    afterBright() {
      this.form_id = this.item.id;
      this.getDetailPreval(this.item.id);
      this.getVendors();
    },
    async getDetailPreval(id) {
      this.loadingPreval = true;
      const res = await this.$store.dispatch('sshcp/detailPrevalNumber', id);
      this.loadingPreval = false;
      this.preval = res.data.result;
      this.preval.local_status = res.data.result?.local_status
        .split('_')
        .join(' ');
      if (res.data.result.vendor_name) {
        this.preval.vendor = {
          name: res.data.result.vendor_name,
          email: res.data.result.vendor_email
        };
      }
    },
    async getVendors() {
      this.dialogBright = true;
      this.loadingVendor = true;
      await this.$store.dispatch('sshcp/getVendor', {
        paginate: false
      });
      this.loadingVendor = false;
    },
    uploadPrevalNumber() {
      Swal.fire({
        title: '',
        text: `Are you sure want to submit this data?`,
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          if (this.preval.local_status === 'waiting for receipt') {
            this.approvePrevalNumber();
          } else {
            this.submitPrevalNumber();
          }
        }
      });
    },
    approvePreval() {
      let text =
        this.preval.local_status === 'waiting to complete'
          ? 'complete'
          : 'approve';
      Swal.fire({
        title: '',
        text: `Are you sure want to ${text} this data?`,
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          this.approvePrevalNumber();
        }
      });
    },
    async approvePrevalNumber() {
      this.loadingSubmitPreval = true;

      let userMapping = JSON.parse(localStorage.getItem('sshcp_mapping'));
      let group_name = userMapping[0].group_name;

      let body = {
        form_id: this.form_id,
        group_name: group_name
      };

      let hasUrlDocReceipt = !!this.preval.receipt.s3_url;
      if (
        !hasUrlDocReceipt &&
        this.preval.local_status === 'waiting for receipt'
      ) {
        await this.uploadFile(this.preval.receipt, 'invoiceDoc');
        body.receipt = this.preval.receipt;
      }
      const res = await this.$store.dispatch('sshcp/approvePreval', body);

      if (res.code === 200) {
        this.loadingSubmitPreval = false;
        this.closeDialog();
        this.$emit('fetchData');
        Swal.fire('Success!', res.message.text_en, 'success');
      } else {
        this.loadingSubmitPreval = false;
        Swal.fire('Failed!', res.message.text_en, 'error');
      }
    },
    async submitPrevalNumber() {
      this.loadingSubmitPreval = true;
      let hasUrlDoc = !!this.preval.prevalDoc.s3_url;
      if (!hasUrlDoc) {
        await this.uploadFile(this.preval.prevalDoc, 'prevalDoc');
      }

      let form = {
        form_id: this.form_id,
        preval_number: this.preval.preval_number,
        vendor_name: this.preval.vendor.name,
        vendor_email: this.preval.vendor.email,
        preval_document: this.preval.prevalDoc
      };

      const res = await this.$store.dispatch('sshcp/submitPrevalNumber', form);

      if (res.code === 200) {
        this.loadingSubmitPreval = false;
        this.closeDialog();
        this.$emit('fetchData');
        Swal.fire('Success!', res.message.text_en, 'success');
      } else {
        this.loadingSubmitPreval = false;
        Swal.fire('Failed!', res.message.text_en, 'error');
      }
    },
    rejectPreval() {
      Swal.fire({
        title: '',
        text: `Are you sure want to reject this data?`,
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          this.rejectPrevalNumber();
        }
      });
    },
    async rejectPrevalNumber() {
      this.loadingRejectPreval = true;

      let body = {
        form_id: this.form_id
      };
      const res = await this.$store.dispatch('sshcp/rejectPreval', body);

      if (res.code === 200) {
        this.loadingRejectPreval = false;
        this.closeDialog();
        this.$emit('fetchData');
        Swal.fire('Success!', res.message.text_en, 'success');
      } else {
        this.loadingRejectPreval = false;
        Swal.fire('Failed!', res.message.text_en, 'error');
      }
    },
    async uploadFile(file, type) {
      let formData = new FormData();
      formData.append('docs', file);
      await this.$store
        .dispatch('sshcp/uploadSuppDocs', formData)
        .then(data => {
          if (data.code === 200) {
            if (type === 'prevalDoc') {
              this.preval.prevalDoc = data.data.result;
            } else {
              this.preval.receipt = data.data.result;
            }
          } else {
            this.loadingSubmitPreval = false;
            Swal.fire('Failed!', data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.loadingSubmitPreval = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    closeDialog() {
      this.dialog = false;
      this.preval = {
        preval_number: '',
        vendor: {},
        prevalDoc: null,
        receipt: null,
        local_status: ''
      };
    }
  }
};
</script>
